import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const UnassignTask = ({ changes: { task, previous_owner }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        Task: {task}
      </Text>
      <Text color="grey800" display="block">
        {previous_owner && <>Previous owner: {previous_owner}</>}
      </Text>
    </Spacer>
  );
};

export default UnassignTask;
